const locale = require('./quoteSummaries.i18n.json');

/*@ngInject*/
const QuoteSummariesController = function ($scope, $rootScope, $timeout, $stateParams, quoteMediator,
                                                          submissionConstant, currencyUtil, coreConstant,
                                                          coreMediator, dateUtil, appTypeConfigurationModel) {

    $scope.i18n = locale;

    $scope.viewModel = {
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
        isLoading: true,
        quotes: [],
        isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation()
    };

    function loadQuotes() {
        let submissionId = $stateParams.submissionId,
            proposalId = $stateParams.proposalId;

        $scope.viewModel.isLoading = true;

        quoteMediator.getQuoteList(submissionId, proposalId).then(function (quotes) {
            $scope.viewModel.quotes = _.map(quotes, function (quote) {
                quote.currencyFormat = currencyUtil.getCurrencyFormat(quote.currencyCode);
                return quote;
            });
            $scope.viewModel.isLoading = false;
        });
    }

    $scope.openQuote = function (quote) {
        $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, quote.objectUri);
    };

    $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, quoteSummary) {
        let index = _.indexOf($scope.viewModel.quotes, _.find($scope.viewModel.quotes, {id: quoteSummary.id}));
        $timeout(function () {
            if (index >= 0) {
                $scope.viewModel.quotes.splice(index, 1, quoteSummary);
            }
            else if (quoteSummary.proposalId === parseInt($stateParams.proposalId)) {
                $scope.viewModel.quotes.push(quoteSummary);
            }
        }, 0);
    });

    $scope.$on(coreConstant.event.QUOTE_DELETED, function (event, quoteSummary) {
        $timeout(function () {
            _.remove($scope.viewModel.quotes, {id: quoteSummary.id});
        }, 0);
    });

    loadQuotes();
};

angular.module('gw-um-submission')
    .controller('quoteSummariesController', QuoteSummariesController);
